export default __webpack_public_path__ + "static/media/0002.4edcb34a.svg";